<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <path d="M21 2H3v20h18z" />
      <path
        d="M16.655 14.157a1.655 1.655 0 1 1 0 3.31a1.655 1.655 0 0 1 0-3.31ZM3 19.944l5.383-4.256L17.343 22M12.269 5h-6.27M18 8.344H6m15 3.219H3" />
    </g>
  </svg>
</template>
